import styled from 'styled-components';
import { getBaseTheme } from '@Themes';

export const NavTitle = styled.span`
    font-size: ${getBaseTheme().texts.sizes.l.fontSize};
    font-weight: bold;
    text-transform: capitalize;
`;

export const TopNavContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: ${props => (props.isAuth ? 'auto' : 'center')};
    position: relative;
    background-color: ${getBaseTheme().colors.area.default.backgroundColor};
    border-bottom: 1px solid ${getBaseTheme().colors.area.default.strokeColor};
    color: ${getBaseTheme().colors.area.default.foregroundColor};
    padding: 0 ${getBaseTheme().spaces.default.xs};
    height: 42px;
    width: 100%;
`;
